import axios from 'axios'
import moment from 'moment'

import store from '@/store'

// Errores que manejamos individualmente, sin usar el handler por defecto
const customErrorsHandlers = [
  'AUTOMATION_ERR'
]

export default () => {
  // Set the default URL that axios will use
  axios.defaults.baseURL = process.env.VUE_APP_API_URL
  axios.defaults.withCredentials = true
  /**
   * Objetivo: Al sensar un http status code 401 forzar el cierre de la sesion
   * y deslogueo del sistema
   */
  axios.interceptors.response.use((response) => {
    // Obtengo de los headers el TTL para saber precisamente cuando se vence la cookie para navegar
    const ttl = Number(response.headers['x-ttl'])
    store.commit('session/updateTokenExpiresAt', { ttl })
    return response
  }, async (error) => {
    if (typeof error.response !== 'undefined' && error.response.status === 401) {
      if (process.env.NODE_ENV === 'development') {
        console.log('error 401 obtenido')
      }
      const noGuardRequired = ['/login', '/404', '/callback', '/restore-password', '/document-sign', '/bibliotecapublica']
      if (location.pathname !== '/login' && !noGuardRequired.includes('/' + location.pathname.split('/')[1])) {
        try {
          await store.dispatch('session/logout')
        } catch (error) {
          console.log('axios interceptor logout error', error)
        } finally {
          const redirect = location.pathname !== '/' ? `?redirect=${location.pathname}` : ''
          location.href = '/login' + redirect
        }
      }
    }
    let showError = true
    let errorToShow = {
      error: '',
      message: '',
      statusCode: '',
      quotaError: false,
      quotaMessage: null
    }
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error?.response?.data?.data?.inAppErrCode === 600) {
        errorToShow.quotaError = true
        errorToShow.message = error?.response?.data?.message
        errorToShow.quotaMessage = error?.response?.data?.data?.quotaMessage
      } else if (error?.response?.data?.data?.customMessage || error?.response?.data?.customMessage) {
        errorToShow.message = error?.response?.data?.data?.customMessage || error?.response?.data?.customMessage
      } else {
        if (error.response.status === 401) {
          errorToShow.message = 'Lo sentimos, su sesión ha expirado'
          showError = false
        } else if (error.response.status === 502 || (error.response.status === 400 && error.response.data.message === 'invalid')) {
          errorToShow.message = 'Lo sentimos, ha ocurrido un error, por favor intente más tarde'
        } else if (error.response.status === 404) {
          errorToShow.message = 'Lo sentimos, no pudimos encontrar lo que buscaba'
        } else if (error.response.status === 400 && error.response.message === 'invalid') {
          errorToShow.message = 'Lo sentimos, ha ocurrido un error, por favor intente más tarde'
        } else {
          errorToShow.message = error.response.data.message
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      errorToShow.error = ''
      errorToShow.message = error.toString()
      errorToShow.statusCode = ''
      showError = false
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
    }
    if (showError && !customErrorsHandlers.includes(error?.response?.data?.type || null)) {
      store.dispatch('notifications/showRequestError', errorToShow)
    }
    // If error happened, redirect to back
    // setTimeout(() => {
    //   history.go(-1)
    // }, 500)
    return Promise.reject(error)
  })

  /**
   * Objetivo: lograr detectar cuando un request se intente hacer con un
   * token expirado, renovarlo y continuar con el request pero usando
   * el nuevo token renovado descartando el viejo.
   */
  axios.interceptors.request.use(async config => {
    const dateNow = new Date()

    if (config?.headers?.Authorization && moment(dateNow).isSameOrAfter(store.state.session.tokenExpiryWarning)) {
      if (process.env.NODE_ENV === 'development') {
        console.log('el token ya expiro se desloguea la sesion')
      }
      store.dispatch('session/logout')
      return false
    } else {
      return config
    }
  }, (err) => {
    return Promise.reject(err)
  })
}
